import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Anthem Blue Cross and Blue Shield of Indiana",
  shortName: "Anthem BCBS Indiana",
  slug: "anthem-bcbs-indiana-insurance",
  seoTitle: "Anthem BCBS Indiana TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Anthem Blue Cross Blue Shield of Indiana? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Anthem BCBS Indiana plan in Coral Springs, FL.",
  seoKeywords:
    "Anthem BCBS Indiana TMS coverage, Anthem Indiana TMS therapy, Anthem BCBS Indiana depression treatment Florida, Anthem Indiana mental health benefits Coral Springs FL, Anthem BCBS Indiana SAINT TMS",
  planType: "Blue Cross Blue Shield affiliate health insurance plan",
  planRegion: "Indiana",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health and substance use disorder services",
  planSpecificIntro:
    "Anthem Blue Cross and Blue Shield of Indiana is an independent licensee of the Blue Cross Blue Shield Association, providing health coverage to members across Indiana. Anthem BCBS Indiana plans typically include behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. However, coverage for TMS, accelerated TMS protocols like SAINT, and other advanced depression treatments varies by individual plan — your specific policy, network status, and prior treatment documentation all play a role.",
  officialResourceUrl: "https://www.anthem.com/",
  officialResourceLabel: "Anthem Blue Cross Blue Shield official website",
};

export const AnthemBcbsIndianaInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AnthemBcbsIndianaInsurance;
